<template>
    <right-filter-drawer
        v-model="showFilterDrawer"
        :title="title"
        :disable-apply="isFiltersEmpty || !isFormValid"
        :disable-clear="isFiltersEmpty"
        @cancel="onCancelFilters"
        @apply="onApplyFilters"
        @clear="onClearFilters"
    >
        <template v-slot:content>
            <v-form ref="form" v-model="isFormValid">
                <form-generator
                    v-model="localFilters"
                    :schema="schema"
                    value-class=""
                ></form-generator>
            </v-form>
        </template>
    </right-filter-drawer>
</template>

<script>
import FormLayout from '@/components/FormLayout/VerticalFormLayout';
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import RightFilterDrawer from '@/components/Drawers/RightFilterDrawer';
import filtersMixin from '@/mixins/filtersDrawerMixin';
import filtersSchema from './activityFiltersSchema';
import { mapState } from 'vuex';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'ActivityFilters',
    components: {
        'form-generator': FormGenerator,
        'right-filter-drawer': RightFilterDrawer
    },
    mixins: [filtersMixin],
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => {}
        },
        title: {
            type: String,
            required: false,
            default: 'Activity filters'
        }
    },
    computed: {
        ...mapState('activities', ['eventTypeOptions']),
        schema() {
            const updatedSchema = [...filtersSchema];

            const typeField = updatedSchema.find(
                item => item.name === 'event_type'
            );
            typeField.component.props.items = this.eventTypeOptions;
            return updatedSchema;
        }
    }
};
</script>

<style></style>
